import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {DexApiDraftDbModule} from '../../components/dex/api-draft-direct-usage/dex-api-draft-db.module';
import {DexApiModule} from '../../components/dex/api/dex-api.module';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {DexDynWidgetComponent} from './dex-dyn-widget.component';
import {DEX_DYN_WIDGET_DESCRIPTION} from './dex-dyn-widget.description';
import {DexDynWidgetSettingsComponent} from './settings/dex-dyn-widget-settings.component';
import {DexDynWidgetSettingsService} from './settings/dex-dyn-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        DexApiModule,
        DexApiDraftDbModule // TODO
    ],
    declarations: [
        DexDynWidgetComponent,
        DexDynWidgetSettingsComponent
    ],
    exports: [
        DexDynWidgetComponent
    ],
    providers: [
        DexDynWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_DYN_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexDynWidgetModule {}
